export enum OperationType {
	Read = 'Read',
	Create = 'Create',
	Write = 'Write',
	Delete = 'Delete',
}
